export class FileExplorerCountSecurityAlertsInResourceResponse {
    'count';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FileExplorerCountSecurityAlertsInResourceResponse.attributeTypeMap;
    }
    constructor() {
    }
}
